import { render, staticRenderFns } from "./BerendrechtSluis.vue?vue&type=template&id=7507581b&"
import script from "./BerendrechtSluis.vue?vue&type=script&lang=ts&"
export * from "./BerendrechtSluis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports